import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","sm":"8","md":"8","lg":"6","xl":"6"}},[(_vm.loading)?_c('Loader'):_c('div',[_c('h1',[_vm._v("Termes and Conditions")]),_c('div',{staticClass:"ml-4 mr-4",domProps:{"innerHTML":_vm._s(_vm.termsAndConditions)}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }